import React from 'react'

export default function ItemDetailReveal({
  itemName = 'Tarima #482',
  itemValue = '120 unidades',
  insightLine = 'Detectada en Rack B-12 hace 3 segundos',
  className = 'h-72',
}) {
  return (
    <div
      className={`relative overflow-hidden bg-gray-50 ${className}`}
      style={{
        backgroundImage: 'radial-gradient(circle, rgb(209 213 219) 1px, transparent 1px)',
        backgroundSize: '28px 28px',
      }}
    >
      <div className="absolute left-[38%] top-[38%] h-7 w-7 -translate-x-1/2 -translate-y-1/2 rounded-sm border border-electric-500">
        <span className="absolute inset-0 m-auto h-1.5 w-1.5 animate-ping rounded-full bg-electric-500"></span>
        <span className="absolute inset-0 m-auto h-1.5 w-1.5 rounded-full bg-electric-600"></span>
      </div>

      <div className="absolute left-[46%] top-[46%] w-56 animate-card-reveal rounded-lg bg-navy-900 p-4 shadow-lg sm:w-64">
        <p className="text-sm font-bold text-white">{itemName}</p>
        <p className="text-xs text-neon-300">{itemValue}</p>
        <div className="my-2 h-px bg-white/10"></div>
        <p className="text-xs leading-5 text-white/70">{insightLine}</p>
      </div>
    </div>
  )
}
